import axios from 'axios';
import { store } from '../redux';
import { getRefreshToken, setAuthData } from '../utils/storage';
import { baseUrl } from '../constants';

const REDIRECT_URL = `/login`;
const SEREBRUM_AUTH_URL = `${baseUrl}/user/oauth_login`;

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};
const handleFailedQueue = (axiosInstance, request) => {
    return new Promise(function (resolve, reject) {
        failedQueue.push({ resolve, reject });
    })
        .then(() => {
            return axiosInstance(request);
        })
        .catch((err) => {
            return Promise.reject(err);
        });
};
export const responseInterceptor = (error, axiosInstance) => {
    const request = error.config;
    if (error.response) {
        const status = error.response.status;
        const code = error.response.data?.code;
        const message = error.response.data?.message;

        if (code === 'E_UNAUTHORIZED' && status === 401 && !request._retry) {
            request._retry = true;
            const refreshToken = getRefreshToken();
            if (isRefreshing) {
                return handleFailedQueue(axiosInstance, request);
            }
            if (refreshToken) {
                request._retry = true;
                isRefreshing = true;

                return handleReAuth(refreshToken, request, error, axiosInstance);
            }
        } else if (code === 'authentication_failed') {
            handleInvalidToken();
        } else if (error.response?.data?.extra) {
            const badFields = error.response.data.extra.bad_fields;
            let message = '';
            if (badFields) {
                badFields.forEach((badField) => {
                    message += badField.name + ': ' + badField.message + '\n';
                });
            }
            store.dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: message,
                    status
                }
            });
        } else if (message) {
            store.dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: message,
                    status
                }
            });
        } else {
            store.dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Face some problem! please contact our support team',
                    status
                }
            });
        }
    } else {
        store.dispatch({
            type: 'ADD_MESSAGE',
            payload: {
                text: 'Network Error!',
                status: 500
            }
        });
    }
    return Promise.reject(error);
};

const handleReAuth = (refreshToken, request, error, axiosInstance) => {
    return new Promise(function (resolve, reject) {
        axios
            .post(
                '/user/auth/refresh',
                { refresh: refreshToken },
                {
                    baseURL: baseUrl
                }
            )
            .then(({ data }) => {
                const access = data.access;
                const refresh = data.refresh ? data.refresh : refreshToken;
                setAuthData(access, refresh);
                axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + data.access;
                processQueue(null, data.access);
                resolve(axiosInstance(request));
            })
            .catch((err) => {
                processQueue(err, null);
                const response = error?.response ? error.response : error;
                if (response && response.data) {
                    if (
                        response.data.code === 'E_UNAUTHORIZED' ||
                        response.data.code === 'authentication_failed'
                    ) {
                        handleInvalidToken();
                        return;
                    } else if (response.data?.message) {
                        store.dispatch({
                            type: 'ADD_MESSAGE',
                            payload: {
                                text: response.data?.message,
                                status: 500
                            }
                        });
                    }
                } else {
                    store.dispatch({
                        type: 'ADD_MESSAGE',
                        payload: {
                            text: 'Network Error!',
                            status: 500
                        }
                    });
                }

                reject(err);
            })
            .then(() => {
                isRefreshing = false;
            });
    });
};

export const handleInvalidToken = () => {
    if (process.env.REACT_APP_SEREBRUM_AUTH_REDIRECT === 'true') {
        window.location.replace(SEREBRUM_AUTH_URL);
    } else {
        window.location.replace(REDIRECT_URL);
    }
    localStorage.removeItem('clinic-data');
};
